module.exports = __webpack_public_path__ + "static/media/flyp_logo.84c59b57.svg";